// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV1AttachMortgageToLeadRequest,
  TPublicB2cV1AttachMortgageToLeadModel,
  IMappers,
  TPublicB2cV1AttachMortgageToLeadResponse_,
  TPublicB2cV1AttachMortgageToLeadResponse,
  TPublicB2cV1AttachMortgageToLeadResponse_1,
  TPublicB2cV1AttachMortgageToLeadResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV1AttachMortgageToLeadModel(
  parameters: TPublicB2cV1AttachMortgageToLeadRequest,
): TPublicB2cV1AttachMortgageToLeadModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v1/attach-mortgage-to-lead/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV1AttachMortgageToLeadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV1AttachMortgageToLeadRequest;
}

export async function fetchPublicB2cV1AttachMortgageToLead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV1AttachMortgageToLeadOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV1AttachMortgageToLeadResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV1AttachMortgageToLeadModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV1AttachMortgageToLeadResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV1AttachMortgageToLeadResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV1AttachMortgageToLeadResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV1AttachMortgageToLeadResponse;
}
